export default __webpack_public_path__ + "static/media/personal_grey.9ae052ab.svg";